module.exports = __webpack_public_path__ + "static/img/gold4.8c094feb.webp";